import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaSearch } from "react-icons/fa";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

export default function CustomerTable() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");

  // --- Filter States ---
  const [searchName, setSearchName] = useState("");
  const [searchDivision, setSearchDivision] = useState("");

  useEffect(() => {
    fetchFailedCollectFee();
  }, []);

  const fetchFailedCollectFee = async () => {
    setIsLoading(true);
    try {
      const payload = {
            customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
        language: "en",
        division_id: "",
        student_name: searchName,
      };

      const response = await simplePostCall(
        ApiConfig.customersList,
        JSON.stringify(payload),
      );

      if (response?.result) {
        const formattedData = response.academicYear.map((item, index) => ({
          id: index + 1,
          name: item.student_name || "",
          grade: item.class_name || "",
          division: item.class_division_name || "",
          invoiceno: item.student_id,
        }));

        setData(formattedData);
        setMessage("Data retrieved successfully");
      } else {
        setMessage(response?.message || "No results found");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      setMessage("Error fetching details");
    } finally {
      setIsLoading(false);
    }
  };

  // --- Filtering Logic ---
  const filteredData = data.filter((item) => {
    return (
      item.name.toLowerCase().includes(searchName.toLowerCase()) &&
      item.division.toLowerCase().includes(searchDivision.toLowerCase())
    );
  });

  const handleClear = () => {
    setSearchName("");
    setSearchDivision("");
  };

  return (
    <div className="customer-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Customer</h4>
      </div>

      <div className="yc-list-body">
        {/* Filters */}
        <div className="yc-list-filter">
          <div className="ff-search-wrap">
            <FaSearch className="ff-search-icon" />
            <input
              type="text"
              className="form-control ff-search-input"
              placeholder="Student Name"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </div>
          <button type="button" className="btn btn-primary" onClick={handleClear}>
            Clear
          </button>
        </div>

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-5">
            <div className="yc-list-cell">Sr No</div>
            <div className="yc-list-cell">Student Name</div>
            <div className="yc-list-cell">Grade</div>
            <div className="yc-list-cell">Division</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        {/* Rows */}
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : filteredData.length > 0 ? (
          <div className="yc-list-row-list">
            {filteredData.map((row) => (
              <div key={row.id} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-5">
                  <div className="yc-list-cell">{row.id}</div>
                  <div className="yc-list-cell">{row.name}</div>
                  <div className="yc-list-cell">{row.grade}</div>
                  <div className="yc-list-cell">{row.division}</div>
                  <div className="yc-list-cell yc-list-cell-actions">
                    <button
                      type="button"
                      className="yc-action-icon"
                      onClick={() => navigate(`/ViewInvoiceCustomer/${row.invoiceno}`)}
                      title="View"
                    >
                      <FaEye />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">{message || "No Data Found matching your search"}</div>
        )}
      </div>
    </div>
  );
}
